<template>
  <section class="app-main">
    <transition name="fade-transform" mode="out-in">
      <div class="all">
        <div class="rightMenu">
          <!-- <breadcrumb id="breadcrumb-container" class="breadcrumb-container" /> -->
        </div>
        <keep-alive :include="cachedViews">

          <router-view :key="key" />
        </keep-alive>
      </div>
    </transition>
  </section>
</template>

<script>
export default {
  name: "AppMain",
  computed: {
    cachedViews() {
      return this.$store.state.tagsView.cachedViews;
    },
    key() {
      return this.$route.path;
    },
  },
};
</script>

<style lang="scss" scoped>
  .all{
    padding:10px 10px 0 10px;
    box-sizing: border-box;
  }
.rightMenu{
  /*margin-bottom: 30px;*/
}
.app-main {
  /* 50= navbar  50  */
  box-sizing: border-box;

  min-height: calc(100vh - 50px);
  width: 100%;
  min-width: 1200px;
  position: relative;
  overflow: hidden;
  background-color: #F7F8F9;
}

.fixed-header + .app-main {
  /*padding-top: 50px;*/
}

.hasTagsView {

  .app-main {
    /* 84 = navbar + tags-view = 50 + 34 */
    min-height: calc(100vh - 90px);
  }

  .fixed-header + .app-main {
    padding-top: 84px;
  }
}
</style>

<style lang="scss">
// fix css style bug in open el-dialog
.el-popup-parent--hidden {
  .fixed-header {
    padding-right: 15px;
  }
}
</style>
